import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import * as recaptchav3Lib from './recaptchav3Lib';
import * as recaptchaActions from '../../../actions/recaptcha/recaptchaActions';

class Recaptchav3 extends React.Component {
    constructor(props) {
        super(props);
        this.onVerify = this.onVerify.bind(this);

        recaptchav3Lib.getRecaptchaV3(process.env.RECAPTCHAV3_SITE_KEY, props.action, this.onVerify);
    }

    onVerify(response) {
        this.props.persistVerification(response);
    }

    render() {
        return (
            <span className="rec-recaptcha" />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        persistVerification: (verification) => dispatch(recaptchaActions.persistVerification(verification))
    }
}

Recaptchav3.propTypes = {
    persistVerification: PropTypes.func,
    action: PropTypes.string
};

export default connect(
    (state) => ({
        verification: state.recaptcha.verification
    }),
    mapDispatchToProps
)(Recaptchav3);
